// extracted by css-extract-rspack-plugin
export default {"backdrop":"multi-pane-panel__backdrop___amOu4"};